import { FilterItem, IntegerFilter } from '../../services/types/services'
import { StateIntegerFilter } from '../slices/filters/types'

export const getSelectedIntegerFilters = ({
  filters,
  integerFilters,
}: {
  filters: FilterItem[]
  integerFilters: StateIntegerFilter[]
}): IntegerFilter[] => {
  return filters.filter(
    f =>
      f.__typename === 'IntegerFilter' &&
      integerFilters.some(
        integerFilter => integerFilter.integerId === f.integerId,
      ) &&
      f.selectedValue !== null,
  ) as IntegerFilter[]
}
